import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { setAccountDatas } from "./accountDatas";

const currentAccountSlice = createSlice({
  name: "currentAccount",
  initialState: {
    accountIndex: window.sessionStorage.getItem("selectedAccount") ?? 0,
    accountNumber: undefined,
    supplyNodeRef: undefined,
    customerNumber: undefined,
    active: undefined,
    icpNumber: undefined,
    address: undefined,
    nativeRenderMode: false,
    usageType: undefined,
    locationClassification: undefined,
    application_journey_ref: undefined,
  },
  reducers: {
    setStoreCurrentAccount: (
      state,
      action: PayloadAction<{
        accountIndex: string;
        accountDatas: AccountInfo[];
      }>,
    ) => {
      state.accountIndex = action.payload.accountIndex;
      window.sessionStorage.setItem(
        "selectedAccount",
        action.payload.accountIndex,
      );

      const selectedAccount =
        action.payload.accountDatas[action.payload.accountIndex]?.attributes;
      state.accountNumber = selectedAccount?.account_number || undefined;
      state.supplyNodeRef = selectedAccount?.supply_node_ref || undefined;
      state.customerNumber = selectedAccount?.main_customer || undefined;
      state.active = selectedAccount?.active || false;
      state.icpNumber = selectedAccount?.main_icp_number || undefined;
      state.address = selectedAccount?.address || undefined;
      state.application_journey_ref =
        selectedAccount?.application_journey_ref || undefined;
    },
    setNativeRenderMode: (
      state,
      action: PayloadAction<{ nativeRenderMode: boolean }>,
    ) => {
      if (action.payload.nativeRenderMode !== state.nativeRenderMode) {
        state.nativeRenderMode = action.payload.nativeRenderMode;
      }
    },
    setCurrentAccountUsageType: (
      state,
      action: PayloadAction<{ usageType: UsageType }>,
    ) => {
      state.usageType = action.payload.usageType;
    },
    setCurrentAccountLocationClassification: (
      state,
      action: PayloadAction<{ locationClassification: LocationClassification }>,
    ) => {
      state.locationClassification = action.payload.locationClassification;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      setAccountDatas,
      (state, action: PayloadAction<{ accountDatas: AccountInfo[] }>) => {
        const { accountDatas } = action.payload;
        accountDatas.sort(
          (account, nextAccount) =>
            Number(nextAccount?.attributes.active) -
            Number(account?.attributes.active),
        );
        const selectedAccount = accountDatas[state.accountIndex]?.attributes;
        state.accountNumber = selectedAccount?.account_number || undefined;
        state.supplyNodeRef = selectedAccount?.supply_node_ref || undefined;
        state.customerNumber = selectedAccount?.main_customer || undefined;
        state.active = selectedAccount?.active || false;
        state.icpNumber = selectedAccount?.main_icp_number || undefined;
        state.address = selectedAccount?.address || undefined;
        state.application_journey_ref =
          selectedAccount?.application_journey_ref || undefined;
      },
    );
  },
});

export const {
  setStoreCurrentAccount,
  setNativeRenderMode,
  setCurrentAccountUsageType,
  setCurrentAccountLocationClassification,
} = currentAccountSlice.actions;
export const currentAccountSliceReducer = currentAccountSlice.reducer;
